export enum PaymentMethod {
  PAYPAL = 'paypal',
  CASH = 'cash',
  CREDIT_CARD = 'credit_card',
  SEPA = 'sepa',
  BALANCE = 'balance',
  POS = 'pos',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
  SOFORTBANKING = 'sofortbanking',
  WALLEE = 'wallee',
  POSTFINANCE = 'postfinance',
  POSTFINANCE_CARD = 'postfinance_card',
  REKA = 'reka',
  TWINT = 'twint',
  LUNCHECK = 'luncheck',
  BONCARD = 'boncard',
  ALIPAY = 'alipay',
  WECHAT = 'wechat',
  CARD_WORLDLINE = 'worldline',
  WORLDLINE_RAW = 'worldline_raw',
  TAC = 'tac',
  CCV = 'ccv',
  ZERO_PAYMENT = 'zero_payment',
  WOLT = 'wolt',
  EC = 'ec',
  GIROCARD = 'girocard',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  VISA = 'visa',
  VISA_E = 'visa_e',
  VPAY = 'vpay',
  JCB = 'jcb',
  MAESTRO = 'maestro',
  OTHER = 'other',
  VR_SEPA = 'vr_sepa',
  BANK_TRANSFER = 'bank_transfer',
  DINERS = 'diners',
  DISCOVER = 'discover',
  SUBSIDY = 'subsidy',
  PIGGY_GIFT_CARD = 'piggy_gift_card',
  PIGGY_PREPAID_BALANCE = 'piggy_prepaid_balance',
  COMO_GIFT_CARD = 'como_gift_card',
  MILES_AND_MORE = 'miles_and_more',
  KOST_CARD = 'kost_card',
  WORLDLINE_MOBILE_APPLE_PAY = 'worldline_mobile_apple_pay',
  WORLDLINE_MOBILE_CREDIT_CARD = 'worldline_mobile_credit_card',
  WORLDLINE_MOBILE_GOOGLE_PAY = 'worldline_mobile_google_pay',
  WORLDLINE_APPLE_PAY = 'worldline_apple_pay',
  WORLDLINE_CREDIT_CARD = 'worldline_credit_card',
  WORLDLINE_GOOGLE_PAY = 'worldline_google_pay',
  IDEAL = 'ideal',
  MEAL_VOUCHER_FR = 'meal_voucher_fr',
  BON_BON_GIFT_CARD = 'bon_bon_gift_card',
  DELIVEROO = 'deliveroo',
  SWISH = 'swish',
  VIPPS = 'vipps',
  MOBILE_PAY = 'mobile_pay',
  DANKORT = 'dankort',
  MAXXVEND = 'maxxvend',
}
